import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../assets/icons/Icon.svg';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom




function DigitalLibrary() {
  const { t } = useTranslation();

  return (
    <div className="digital-twin-page">
        
      {/* SANGE 
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={Icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">
            {t('digital_library_section1')}
          </h3>
          <p className="data-governance-card-description">
            {t('digital_library_section1_desc1')}
          </p>
          <p className="data-governance-card-description">
            {t('digital_library_section1_desc2')}
          </p>
          <div className="data-governance-card-footer">
          <span></span><Link className="nav-link" to="/SANGE"> <button class="data-governance-card-link" id="readMoreBtn" > {t('read-more')}</button></Link>

          </div>
        </div>
      </div>*/}
       {/* KSA MAP */}
       <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={Icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">
            {t('digital_library_section2')}
          </h3>
          <p className="data-governance-card-description">
            {t('digital_library_section2_desc1')}
          </p>
          <div className="data-governance-card-footer">
          <span></span><Link className="nav-link" to="/SOCIO-ECONOMIC-IMPACT"> <button class="data-governance-card-link" id="readMoreBtn" > {t('read-more')}</button></Link>

          </div>
        </div>
      </div>
      {/* SLA */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={Icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">
            {t('digital_library_SLA')}
          </h3>
          <p className="data-governance-card-description">
            {t('digital_library_SLA_desc1')}
          </p>
          <div className="data-governance-card-footer">
          {/* <span></span><Link className="nav-link" to="/Effective-Geospatial-Collaboration"> <button class="data-governance-card-link" id="readMoreBtn" > {t('read-more')}</button></Link> */}
           <span></span><a href={t('SLA_DOC')} download><button class="data-governance-card-link" id="readMoreBtn" > {t('read-more')}</button>
                </a>

          </div>
        </div>
      </div>
      {/* SANGE Establishment */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={Icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">
            {t('SANGE_Establishment')}
          </h3>
         {/*  <p className="data-governance-card-description">
            {t('digital_library_SLA_desc1')}
          </p> */}
          <div className="data-governance-card-footer">
          {/* <span></span><Link className="nav-link" to="/SANGE_Establishment"> <button class="data-governance-card-link" id="readMoreBtn" > {t('read-more')}</button></Link> */}
          <span></span><a href={t('SANGE_Establishment_pdf')} download><button class="data-governance-card-link" id="readMoreBtn" > {t('read-more')}</button>
                </a>

          </div>
        </div>
      </div>
       {/* Governance */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={Icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">
            {t('Digital_Library_Gov_doc')}
          </h3>
         {/*  <p className="data-governance-card-description">
            {t('digital_library_SLA_desc1')}
          </p> */}
          <div className="data-governance-card-footer">
          {/* <span></span><Link className="nav-link" to="/KSANatioanlGeospatialGovernance"> <button class="data-governance-card-link" id="readMoreBtn" > {t('read-more')}</button></Link> */}
          <span></span><a href={t('Digital_Library_Gov_docpdf')} download><button class="data-governance-card-link" id="readMoreBtn" > {t('read-more')}</button>
                </a>
          </div>
        </div>
      </div>
       {/* GKI Readiness */}
      <div className="data-governance-card">
        <div className="data-governance-card-image">
          <img src={Icon} alt="Icon" />
        </div>
        <div className="data-governance-card-content">
          <h3 className="data-governance-card-title">
            {t('Digital_Library_GKI')}
          </h3>
         {/*  <p className="data-governance-card-description">
            {t('digital_library_SLA_desc1')}
          </p> */}
          <div className="data-governance-card-footer">
          <span></span><Link className="nav-link" to="/GKIReadinessIndex"> <button class="data-governance-card-link" id="readMoreBtn" > {t('read-more')}</button></Link>

          </div>
        </div>
      </div>
    </div>
  );
}

export default DigitalLibrary;
